import { render, staticRenderFns } from "./FaceMesh.vue?vue&type=template&id=213263f9&scoped=true"
import script from "./FaceMesh.vue?vue&type=script&lang=js"
export * from "./FaceMesh.vue?vue&type=script&lang=js"
import style0 from "./FaceMesh.vue?vue&type=style&index=0&id=213263f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213263f9",
  null
  
)

export default component.exports